// GAVION recruiting: « Recrutement » (admins only).
export const recruitingFr = {
  title: "Recrutement",
  intro:
    "Les postes publiés paraissent sur gavion.ai dans les 5 minutes ; les candidatures du site arrivent ici. Réservé aux administrateurs.",
  badge:
    "%{smart_count} nouvelle candidature |||| %{smart_count} nouvelles candidatures",
  tabs: { postings: "Postes", applications: "Candidats" },
  posting_status: { draft: "Brouillon", published: "Publié", closed: "Fermé" },
  employment_type: {
    full_time: "Temps plein",
    part_time: "Temps partiel",
    contract: "Contrat",
    commission: "À commission",
    internship: "Stage",
  },
  remote: { onsite: "Sur place", hybrid: "Hybride", remote: "À distance" },
  // GAVION manual-candidates: where the candidate came from
  source: {
    website: "Site web",
    indeed: "Indeed",
    referral: "Référence",
    other: "Autre",
  },
  add: {
    button: "Ajouter un candidat",
    title: "Ajouter un candidat",
    description:
      "Un candidat reçu ailleurs que sur le site (Indeed, une référence…). Il est évalué par l'IA et conservé 12 mois, comme les autres.",
    fields: {
      uid: "Identifiant",
      name: "Nom",
      posting_id: "Poste",
      source: "Source",
      contact: "Courriel ou téléphone",
      email: "Courriel",
      phone: "Téléphone",
      availability: "Disponibilités (facultatif)",
      profile_url: "Lien vers le profil (facultatif)",
      message: "Message / notes (facultatif)",
      cv: "CV (facultatif)",
      letter: "Lettre de présentation (facultatif)",
    },
    choose_posting: "Choisir un poste…",
    contact_hint: "Courriel ou téléphone : au moins un des deux.",
    profile_url_hint: "Adresse https:// (Indeed, LinkedIn…).",
    file_hint: "PDF, DOC ou DOCX, 2 Mo au plus.",
    save: "Ajouter",
    cancel: "Annuler",
    added_toast: "Candidat ajouté. L'évaluation IA suit dans quelques minutes.",
    errors: {
      required: "Obligatoire.",
      invalid: "Valeur invalide.",
      invalid_email: "Adresse courriel invalide.",
      invalid_phone: "Numéro nord-américain invalide (10 chiffres).",
      invalid_profile_url: "Le lien doit commencer par https://.",
      contact_required: "Indiquez un courriel ou un téléphone.",
      too_long: "Trop long.",
      file_type: "Seuls les fichiers PDF, DOC ou DOCX sont acceptés.",
      file_size: "Le fichier doit faire 2 Mo au plus.",
    },
  },
  application_status: {
    new: "Nouveau",
    interview: "Entrevue",
    offer: "Offre",
    hired: "Embauché",
    rejected: "Refusé",
  },
  postings: {
    new: "Nouveau poste",
    empty: "Aucun poste pour l'instant. Créez-en un avec « Nouveau poste ».",
    col_title: "Poste",
    col_status: "Statut",
    col_published: "Publié le",
    col_applications: "Candidatures",
    edit: "Modifier",
    publish: "Publier",
    close: "Fermer",
    republish: "Republier",
    delete: "Supprimer",
    view_on_site: "Voir sur le site",
    delete_title: "Supprimer ce brouillon ?",
    delete_body: "Le poste « %{title} » sera supprimé.",
    cancel: "Annuler",
    published_toast: "Poste publié : il paraît sur le site dans les 5 minutes.",
    closed_toast: "Poste fermé : il disparaît du site dans les 5 minutes.",
    deleted_toast: "Brouillon supprimé.",
  },
  form: {
    create_title: "Nouveau poste",
    edit_title: "Modifier le poste",
    french: "Français (obligatoire)",
    english: "Anglais (facultatif)",
    title_fr: "Titre",
    title_en: "Titre (EN)",
    description_fr: "Description (Markdown)",
    description_en: "Description (EN, Markdown)",
    requirements_fr: "Exigences (Markdown)",
    requirements_en: "Exigences (EN, Markdown)",
    pay_text_fr: "Rémunération (texte libre)",
    pay_text_en: "Rémunération (EN)",
    pay_hint: "Ex. : 45 000 $ – 55 000 $ + commissions",
    employment_type: "Type d'emploi",
    location: "Lieu",
    location_hint: "Ex. : Montréal (hybride)",
    remote: "Mode de travail",
    slug: "Adresse sur le site",
    slug_hint:
      "Lettres minuscules, chiffres et traits d'union. Vide = tirée du titre français.",
    slug_locked:
      "Le poste a déjà été publié : son adresse est verrouillée pour ne pas briser les liens partagés.",
    public_url: "Adresse publique : %{url}",
    preview: "Aperçu",
    edit_tab: "Rédaction",
    save: "Enregistrer",
    saved_toast: "Poste enregistré.",
    cancel: "Annuler",
  },
  applications: {
    empty: "Aucune candidature.",
    filter_posting: "Poste",
    filter_status: "Statut",
    all_postings: "Tous les postes",
    spontaneous: "Candidature spontanée",
    all_statuses: "Tous les statuts",
    col_date: "Reçue le",
    col_name: "Nom",
    col_posting: "Poste",
    col_status: "Statut",
    col_cv: "CV",
    col_availability: "Disponibilités",
    has_cv: "CV joint",
    not_found: "Cette candidature n'existe plus.",
    select_hint: "Choisissez une candidature pour l'ouvrir.",
    col_score: "Score IA",
    sort_by_score: "Trier par score IA",
    review_pending: "Évaluation en cours",
    review_none: "Pas de score",
  },
  detail: {
    contact: "Coordonnées",
    email: "Courriel",
    phone: "Téléphone",
    language: "Langue",
    received: "Reçue le %{at}",
    message: "Message",
    no_message: "Aucun message.",
    open_cv: "Ouvrir le CV",
    open_letter: "Ouvrir la lettre",
    cover_letter: "Lettre de présentation",
    availability: "Disponibilités pour une entrevue",
    no_cv: "Aucun CV joint.",
    status: "Statut",
    notes: "Notes",
    no_notes: "Aucune note.",
    note_placeholder: "Ajouter une note…",
    add_note: "Ajouter la note",
    delete: "Supprimer",
    delete_title: "Supprimer cette candidature ?",
    delete_body:
      "La candidature de %{name}, ses notes et son CV seront supprimés définitivement.",
    cancel: "Annuler",
    deleted_toast: "Candidature supprimée.",
    purge_on: "Supprimé automatiquement le %{date}",
    kept_hired: "Conservé : embauché",
    close: "Fermer",
    languages: { fr: "Français", en: "Anglais" },
    profile: "Profil",
    open_profile: "Ouvrir le profil",
    manual_message: "Message / notes",
  },
  ai_review: {
    title: "Évaluation IA (indicative)",
    disclaimer: "Aide au tri seulement. Une personne décide.",
    rerun: "Réévaluer",
    requested:
      "Réévaluation demandée. Le résultat arrive dans quelques minutes.",
    none: "Pas encore évaluée. Cliquez sur « Réévaluer ».",
    pending: "Évaluation en cours… (quelques minutes)",
    unreadable: "CV illisible, à lire manuellement.",
    failed: "L'évaluation a échoué. Réessayez avec « Réévaluer ».",
    posting_changed: "Poste modifié depuis l'évaluation",
    score: "%{score} / 100",
    reviewed_at: "Évaluée le %{at}",
    verdict: { strong: "Fort", consider: "À considérer", weak: "Faible" },
    rating: {
      met: "Satisfait",
      partial: "Partiel",
      missing: "Manquant",
      unknown: "Inconnu",
    },
    col_requirement: "Exigence",
    col_rating: "Résultat",
    col_evidence: "Preuve dans les documents",
    strengths: "Forces",
    concerns: "Points à vérifier",
    questions: "Questions d'entrevue",
  },
  erase: {
    title: "Effacer un candidat",
    hint: "Efface toutes les candidatures envoyées avec cette adresse courriel, leurs notes, leurs CV et leurs lettres (Loi 25). Les compagnies et les contacts ne sont pas touchés.",
    email: "Adresse courriel du candidat",
    reason: "Raison",
    ack: "Je comprends que cette action est irréversible.",
    button: "Effacer les candidatures",
    done: "%{smart_count} candidature effacée |||| %{smart_count} candidatures effacées",
    files:
      "%{smart_count} fichier en file de suppression |||| %{smart_count} fichiers en file de suppression",
  },
  errors: {
    forbidden: "Réservé aux administrateurs.",
    not_found: "Introuvable : la page a peut-être changé. Rechargez-la.",
    invalid_posting: "Vérifiez le champ « %{field} ».",
    slug_taken: "Cette adresse est déjà prise par un autre poste.",
    slug_locked:
      "Le poste a déjà été publié : son adresse ne peut plus changer.",
    invalid_transition: "Cette action n'est pas possible pour ce poste.",
    posting_not_deletable:
      "Seul un brouillon sans candidature peut être supprimé. Fermez plutôt le poste.",
    invalid_note: "La note est vide ou trop longue (5 000 caractères au plus).",
    invalid_status: "Statut inconnu.",
    cv_unavailable: "Le CV n'est pas disponible.",
    invalid_email: "Adresse courriel invalide.",
    invalid_reason: "Choisissez une raison.",
    too_soon: "Une réévaluation a déjà été demandée il y a moins d'une minute.",
    invalid_application: "Vérifiez le champ « %{field} ».",
    file_upload_failed: "L'envoi du fichier « %{field} » a échoué. Réessayez.",
    network: "Erreur réseau. Réessayez.",
    unknown: "L'action a échoué. Réessayez.",
  },
};
